"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.display = void 0;
var type_guard_1 = require("@webnuts/type-guard");
exports.display = type_guard_1.enums([
    'initial',
    'inherit',
    'unset',
    'block',
    'inline',
    'inline-block',
    'flex',
    'inline-flex',
    'none'
]);
